import { useEffect } from 'react';
import { debounce } from 'throttle-debounce';

/** Adds a CSS variable to the HTML element, that says the width of a browser scrollbar. This can be helpful because
 * 100vw is 100% of the viewport, but also includes the width of the scrollbar. You can use the CSS varaible in
 * CSS calc functions to get the true visible width of the viewport.
 *
 * Any components that use the scroll bar width CSS variable should add the component somewhere in their hierarchy. The
 * component cannot be added to the root of the site, as the components for a page may not be immediately rendered when
 * this component performs its measurements
 */
export default function ScrollbarWidthCssVariable() {
  useEffect(() => {
    const setScrollbarWidthVar = () => {
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;

      document.documentElement.style.setProperty(
        '--browser-computed-scrollbar-width',
        `${scrollbarWidth}px`,
      );
    };

    // Run immediately
    setScrollbarWidthVar();

    // Debounced resize handler
    const debounced = debounce(500, setScrollbarWidthVar);
    window.addEventListener('resize', debounced);

    return () => {
      window.removeEventListener('resize', debounced);
    };
  }, []);

  // This component doesn't render anything
  return null;
}
